<template>
  <div class="hmf-inside-banner-main-container">
    <div class="container h-100">
      <div class="row h-100 my-auto">
        <div class="col-12 my-auto">
          <div class="hmf-breadcrumb">Beranda / Data Penanganan</div>
          <div class="hmf-page-title">
            <h1 class="h1-hmf-title">Data Penanganan Aduan Nasabah</h1></div>
        </div>
      </div>
    </div>
  </div>
  <div class="container hmf-main-content-area">
    <PageDataPenanganan
        :useheader=false
        :usebutton=true
    ></PageDataPenanganan>
  </div>
  <PageFooter></PageFooter>
</template>

<script>
import PageFooter from "@/components/part/PageFooter";
import PageDataPenanganan from "@/components/pages/part/PageDataPenanganan";
export default {
  name: "PagePenanganan",
  components: {PageDataPenanganan, PageFooter}
}
</script>

<style scoped>

</style>